import { Box, Button, Typography } from '@mui/material'
import { PageTitle } from '../components/atoms/PageTitle'
import { DeviceDataTable } from '../components/DeviceDataTable'
import { MultioptProxyToggle } from '../components/forms/MultioptProxyToggle'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDevices } from '../hooks/useDevices'
import { useApp } from '../hooks/useApp'
import { ID } from '../types/models'

export function DevicesPage(): React.ReactElement {

  const app = useApp()
  const { control } = useDevices()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isPro = app.userHas('PRO_CONFIG_PAGE')

  const navigateToClaimDevice = () => {
    navigate('/claim')
  }

  // Locations with two or more LAN devices (radio slaves communicate through
  // their master and don't count) can relay multiopt messages via the server.
  const multiDeviceLocations = app.locations.filter(loc =>
    control.devices({ locationId: loc.id as ID }).filter(d => !d.values?.slave_of).length >= 2)

  return (
    <>
      <PageTitle title={t('Enion Devices')}/>

      <Box sx={{ mt: 4 }}>
        <DeviceDataTable link={isPro ? '/config/:id' : '/appliances'} devices={control.devices('ALL')}/>
      </Box>

      {app.installerLevel && multiDeviceLocations.map(loc => (
        <Box sx={{ mt: 2 }} key={loc.id}>
          {app.locations.length > 1 && <Typography variant="h6">{loc.name}</Typography>}
          <MultioptProxyToggle location={loc}/>
        </Box>
      ))}

      <Box sx={{ mt: '1.3rem', textAlign: 'center' }}>
        <Button data-cy="button-Add Device" onClick={navigateToClaimDevice}>{t('Add Enion Device')}</Button>
      </Box>
    </>
  )
}
